import { z } from 'zod';
import { CandidatesConst, CountryCodesConst } from '@axiom/const';
import { ZodArrayToEnum } from '@axiom/types';

const CountryCodes = Object.values(CountryCodesConst.CountryCodesAbbreviations);
const ProfileStatuses = Object.values(CandidatesConst.ProfileStatuses);

export const RequestMLRecommendationsFiltersSchema = z.object({
  addressCountryCode: z.enum(ZodArrayToEnum(CountryCodes)).nullish(),
  addressState: z.array(z.string()).nullish(),
  annualCompensationStart: z
    .number()
    .nonnegative()
    .max(9999999999999.99)
    .nullish(),
  annualCompensationEnd: z
    .number()
    .nonnegative()
    .max(9999999999999.99)
    .nullish(),
  businessTitles: z.array(z.string()).nullish(),
  excludeCandidateIds: z.array(z.string().uuid()).nullish(),
  profileStatus: z.array(z.enum(ZodArrayToEnum(ProfileStatuses))).nullish(),
  size: z.number().min(1).max(10).nullish(),
  weeklyAvailability: z.number().nonnegative().nullish(),
});

export type RequestMLRecommendationsFilters = z.infer<
  typeof RequestMLRecommendationsFiltersSchema
>;

export const RequestMLRecommendationsSchema = z.object({
  filters: RequestMLRecommendationsFiltersSchema,
  opportunityId: z.string().uuid(),
});

export type RequestMLRecommendations = z.infer<
  typeof RequestMLRecommendationsSchema
>;
